<script>
    import Common from "../common/index";

    export default {
        name: "donghua",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                type: 'animation',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'UploadBtn',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            // {
                            //     title: '动画效果1',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                            // {
                            //     title: '动画效果2',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                        ],
                        selected: [0]
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
        }
    }
</script>
